import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface BarChartProps {
  data: { date: string; total: number }[];
  chartTitle: string;
  xAxisLabel: string;
  yAxisLabel: string;
}

const BarChart: React.FC<BarChartProps> = ({
  data,
  chartTitle,
  xAxisLabel,
  yAxisLabel,
}) => {
  const labels = data.map(item => item.date);
  const values = data.map(item => item.total);

  const processedData = { labels, data: values };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
      title: {
        display: false,
        text: chartTitle,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: yAxisLabel,
        },
      },
      x: {
        title: {
          display: true,
          text: xAxisLabel,
        },
      },
    },
  };

  return <Bar data={{
    labels: processedData.labels,
    datasets: [
      {
        label: chartTitle,
        data: processedData.data,
        backgroundColor: "#CCCCFF",
      },
    ],
  }} options={options} />;
};

export default BarChart;
